import { type ReactNode } from 'react';

export function PrepioneersHero(): ReactNode {
  return (
    <header className="space-y-sm">
      <h1 className="font-display text-3xl font-bold leading-none tracking-tight text-white sm:text-4xl">
        Pre<span className="text-brand-red">pioneros</span>
      </h1>
      <p className="max-w-[40rem] text-sm leading-relaxed text-text-secondary">
        Los más de 500.000 prepioneros que se han registrado interesados para
        ser parte del lanzamiento de Debook.
      </p>
    </header>
  );
}
